export default __webpack_public_path__ + "static/media/logo-qubic.372edc7e.svg";